import { render, staticRenderFns } from "./OtherLabourListView.vue?vue&type=template&id=3ffef6a8"
import script from "./OtherLabourListView.vue?vue&type=script&lang=js"
export * from "./OtherLabourListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffef6a8')) {
      api.createRecord('3ffef6a8', component.options)
    } else {
      api.reload('3ffef6a8', component.options)
    }
    module.hot.accept("./OtherLabourListView.vue?vue&type=template&id=3ffef6a8", function () {
      api.rerender('3ffef6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otherlabour/OtherLabourListView.vue"
export default component.exports